import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { IRequestException } from 'api/types/requestException';
import type { IUserProfile } from 'api/types/user';

type IGetUserProps = UseQueryOptions<IUserProfile, IRequestException>;

export const fetchUser = async () => {
    const response = await apiClient.get('users/me', {});
    const user: IUserProfile = await response.json();
    user.disabled = false;
    return user;
    // return (await response.json()) as IUserProfile;
};

export const useGetUserQuery = ({ ...options }: IGetUserProps) => {
    return useQuery<IUserProfile, IRequestException>(
        'user',
        async () => await fetchUser(),
        { ...options }
    );
};
